// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3LEwa","content":"GlobalSearch_content__mpr6y"};